// Fills the PDP "Køb lignende styles" accordion on products without a curated
// custom.accordion_related_products metafield, using Shopify's automatic
// `related` recommendations (sections/pdp-similar-styles.liquid via the
// Product Recommendations route).
//
// The recommendations object is only populated when fetched through that route,
// so we fetch on load and either inject the cards or hide the whole accordion
// item (no empty "Køb lignende styles" header). Loading eagerly — rather than on
// accordion open — means the cards exist before the panel's open animation
// measures its height, and the empty case resolves before the user sees it.
(function () {
  const SELECTOR = 'div.pdp-similar-styles';

  function hide(el) {
    const item = el.closest('[data-acc-item]');
    if (item) item.hidden = true;
  }

  function syncHeights(el) {
    const item = el.closest('[data-acc-item]');
    if (item && item.classList.contains('active')) {
      const content = item.querySelector('[data-acc-content]');
      if (content && !content.hidden) content.style.maxHeight = 'none';
    }
    window.dispatchEvent(new Event('resize'));
  }

  function load(el) {
    if (el.dataset.pdpRecLoaded === 'true') return;
    el.dataset.pdpRecLoaded = 'true';
    const { url, productId, sectionId } = el.dataset;
    if (!url || !productId || !sectionId) return;

    fetch(`${url}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const parsed = document.createElement('div');
        parsed.innerHTML = text;
        // The recommendations route wraps the section in <div id="shopify-section-…">.
        // Inject its inner cards so they become direct flex children of the carousel.
        const section = parsed.querySelector('[id^="shopify-section-"]') || parsed;
        if (section.querySelector('.pcard')) {
          el.innerHTML = section.innerHTML;
          syncHeights(el);
        } else {
          hide(el);
        }
      })
      .catch(() => hide(el));
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
